import environment from "./envConfig";

const BASE_URL = environment.END_POINT.BASE;
export const END_POINTS = {
  TRACKING_URL: `${BASE_URL}/api/v3/service/tracking/shipment`,
  FEEDBACK_URL: `${BASE_URL}/api/v3/service/tracking/feedback`,
  FEEBCACK_TAGS: `${BASE_URL}/api/v3/service/tracking/feedback/options`
}

/**
 * To perform API calls and provide data
 * @param {string} endPoint 
 * @param {string} methodType 
 * @param {object} requestBody 
 * @returns 
 */
export const RequestData = async (endPoint = 'https://api.example.com', methodType = 'GET', requestBody = {}) => {
  let options = {};
  if (Object.keys(requestBody)?.length !== 0) {
    options = {
      method: methodType,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    };
  } else {
    options = {
      method: methodType,
      headers: {
        'Content-Type': 'application/json'
      },
    };
  }
  try {
    const response = await fetch(endPoint, options);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error; // Rethrow the error to be caught by the caller
  }
}


